const REVIEW_NAMES = {
  MSR: 'Medication Safety Review (MSR)',
  MSRL: 'Medication Safety Review Lite (MSR Lite)',
  MSA: 'Medication Safety Advisory (MSA)',
  SOLICITED_TARGETED_MEDICATION_REVIEW: 'Solicited Targeted Medication Review',
  UNSOLICITED_TARGETED_MEDICATION_REVIEW:
    'Unsolicited Targeted Medication Review'
}

module.exports = {
  REVIEW_NAMES
}
